<template>
    <tr :style="[codebarre.codebarre==store.state.barcodeFinded||codebarre.ean13_y2==store.state.barcodeFinded?{'border-bottom': '0.1em solid','border-color':'lightgrey' ,'font-weight': 'bold'}:{'border-bottom': '0.1em solid','border-color':'lightgrey'}]">
        <td @click="emit('photo_name', codebarre.photo_name)"  width="100" style="background-color: antiquewhite;cursor: pointer">
            <span >{{ codebarre.code_couleur }}/{{ codebarre.couleur }}</span><br><span>{{codebarre.ean13_y2&&!cab?codebarre.ean13_y2:codebarre.codebarre}}</span>
        </td>
        <td>{{ codebarre.taille }}</td>
        <td>€<input type="text" 
            :value="Number(codebarre.vte_euro).toFixed(2)" size="5" 
            @input="$event.target.value = $event.target.value
                .replace(',', '.')
                .match(/^\d*\.?\d{0,2}/)?.[0] || '';"
            @change.prevent="updatePrix($event.target.value)"/>
           
        </td>
        <td class="iconplus" width="50" v-if="!visible&&!visiblefunction" @click="visible=true"><v-icon class="iconplus" icon="mdi-plus" ></v-icon></td>
        <td class="iconplus" width="50" v-if="(visible||visiblefunction)&&codebarre.type_promo==''" @click="visible=false"></td>
        <td class="promo" :style="[codebarre.type_promo=='PBG'?typePromoPBG:typePromo]" v-if="(visible||visiblefunction)&&codebarre.type_promo!=''">{{ `${preciseDiscount(codebarre.prix_promo, codebarre.vte_euro).toFixed(0)}%` }}</td>
        <td class="promo" v-if="visible||visiblefunction" @dblclick="getPeriodePromo(codebarre.type_promo)">
        <select class="promo" :style="[codebarre.type_promo=='PBG'?typePromoPBG:typePromo]" @change="addTypePromo($event.target.value)" width="100%">
            <option >{{codebarre.type_promo}}</option>
            <option v-if="typesPromo.length>1" v-for="key in typesPromo">{{key}}</option>
        </select>
        </td >
        <td v-if="visible||visiblefunction" class="promo" :style="[codebarre.type_promo=='PBG'?typePromoPBG:typePromo]"><span v-if="codebarre.prix_promo">€</span><input class="promo"  :style="[codebarre.type_promo=='PBG'?typePromoPBG:typePromo]" type="text" :disabled="codebarre.type_promo==''?true:false" :value="codebarre.prix_promo?Number(codebarre.prix_promo).toFixed(1):''" size="4" @change="addPromo($event.target.value);emit('isChangedCol', isChanged)"/></td>
        <td>
            <select name="collections" id="collections" v-model="codebarre.collection" @change="updateCollection($event.target.value)"  >
                <option >{{codebarre.collection}}</option>
                <option  v-for="key in collections.filter(el=>el!=codebarre.collection)">{{key}}</option>
            </select>
        </td>
        <td class="filiale">
             <v-icon color="primary" @click="getReliquat(codebarre)" title="Afficher les compteurs du code à barre" icon="mdi-information" ></v-icon>
        </td>
        <td  class="filiale"  v-for="el in etabDEPO.etabliss " :key="el" > {{ codebarre.stock[el]?codebarre.stock[el]:'' }}</td>
        <td  class="filiale"  v-if="!['DEPO','DWEB'].find(el=>el==store.state.etablissement)"> {{ codebarre.stock[store.state.etablissement ]?codebarre.stock[store.state.etablissement ]:'' }}</td>
        <td class="filiale">
            <span>{{ sumStock(etabEdiFrNord.etabliss.filter(el=>el!=store.state.etablissement))+sumStock(etabEdiPDC.etabliss.filter(el=>el!=store.state.etablissement))!=0&&!repart?sumStock(etabEdiFrNord.etabliss.filter(el=>el!=store.state.etablissement))+sumStock(etabEdiPDC.etabliss.filter(el=>el!=store.state.etablissement)):'' }}
            </span>
            <span v-if="repart" class="iconplus" @click="repartDialog=true">
            <v-icon  icon="mdi-plus"  ></v-icon>
            </span>
        </td>
        <td class="etabclass" :style="[filiale(codebarre.repart[el],codebarre.stock[el],codebarre.stock['DEPO'])?etabclass2:'' ]"  v-if="col.edisacFranceCol" v-for="el in etabEdiFrNord.etabliss.filter(el=>el!=store.state.etablissement) " :key="el"> 
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>        
        </td>
        <td class="etabclass" :style="[filiale(codebarre.repart[el],codebarre.stock[el],codebarre.stock['DEPO'])?etabclass2:'' ]"  v-if="col.edisacFranceCol"   v-for="el in etabEdiPDC.etabliss.filter(el=>el!=store.state.etablissement) " :key="el">
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>
        </td>

        <td class="filiale"><span>{{ sumStock(etabEdiBE.etabliss.filter(el=>el!=store.state.etablissement))!=0&&!repart?sumStock(etabEdiBE.etabliss.filter(el=>el!=store.state.etablissement)):'' }}</span></td>

        <td  class="etabclass" v-if="col.edisacBelgiqueCol"  :style="[filiale(codebarre.repart[el],codebarre.stock[el],codebarre.stock['DEPO'])?etabclass2:'' ]"  v-for="el in etabEdiBE.etabliss " :key="el">
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>
        </td>
        <td class="filiale"><span>{{ sumStock(etabLc.etabliss.filter(el=>el!=store.state.etablissement))!=0&&!repart?sumStock(etabLc.etabliss.filter(el=>el!=store.state.etablissement)):'' }}</span></td>
        <td class="etabclass" v-if="col.etabLcCol" :style="[filiale(codebarre.repart[el],codebarre.stock[el],codebarre.stock['DEPO'])?etabclass2:'' ]"  v-for="el in etabLc.etabliss.filter(el=>el!=store.state.etablissement) " :key="el" > 
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>
        </td>
        <td class="filiale"><span>{{ sumStock(etabEtrier.etabliss.filter(el=>el!=store.state.etablissement))!=0&&!repart?sumStock(etabEtrier.etabliss.filter(el=>el!=store.state.etablissement)):'' }}</span></td>
        <td class="etabclass"  v-if="col.etabEtrierCol" :style="[filiale(codebarre.repart[el],codebarre.stock[el],codebarre.stock['DEPO'])?etabclass2:'' ]"  v-for="el in etabEtrier.etabliss.filter(el=>el!=store.state.etablissement) " :key="el" >
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>
        </td>
        <td class="filiale"><span>{{ sumStock(etabReflex.etabliss.filter(el=>el!=store.state.etablissement))!=0&&!repart?sumStock(etabReflex.etabliss.filter(el=>el!=store.state.etablissement)):'' }}</span></td>
        <td class="etabclass"  v-if="col.etabReflexCol"   v-for="el in etabReflex.etabliss.filter(el=>el!=store.state.etablissement) " :key="el" > 
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>
        </td>
        <td class="filiale"><span>{{ sumStock(etabAD.etabliss.filter(el=>el!=store.state.etablissement))!=0&&!repart?sumStock(etabAD.etabliss.filter(el=>el!=store.state.etablissement)):'' }}</span></td>
        <td class="etabclass"  v-if="col.etabADCol"   v-for="el in etabAD.etabliss.filter(el=>el!=store.state.etablissement) " :key="el" > 
            <span v-if="!repart">{{ codebarre.stock[el]?codebarre.stock[el]:'' }}</span>
            <span v-else><input type="text" :value="codebarre.repart[el]&&codebarre.repart[el]!=0?codebarre.repart[el]:''" size="1" @change.prevent="updateRepart(el,$event.target.value)"/></span>
        </td>
        <td v-if="localChanged.prixBase">
            <v-icon color="success" @click="validerArticles()" title="exporter les changements" icon="mdi-check-circle" class="exporter"></v-icon>
             <!-- <v-icon color="success" @click="qteDialog=true" title="exporter les changements" icon="mdi-information" class="exporter"></v-icon> -->
        </td>
        <td v-if="toDelete">
            <v-icon color="red" @click="codebarre.type_promo.match(/sol/gmi)?dialogSolde=true:deletePromo()" title="Suprrimer la promo" icon="mdi-delete-forever" class="exporter"></v-icon>
        </td>
    </tr>
    <div  >
        <v-dialog v-model="dialogSolde" width="auto">
          <v-card max-width="400" prepend-icon="$error"
          :text="`Cette couleur est en solde, selectionnez les démarque à suprrimer SVP!`"
          title="Suppression soldes"
          >
          <v-row>
              <v-checkbox label="D1" v-model="d1" style="margin-left: 20%;" ></v-checkbox>
              <v-checkbox label="D2" v-model="d2" ></v-checkbox> 
              <v-checkbox label="D3" v-model="d3" ></v-checkbox>
              <v-checkbox label="OT" v-model="ot" ></v-checkbox>
          </v-row>
          <template v-slot:actions>
              <v-btn color="red" text="Annuler" @click="dialogSolde = false"></v-btn>
              <v-btn color="green" text="Valider" @click="deletePromo();dialogSolde = false"></v-btn>
          </template>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAjoutSolde" width="auto">
          <v-card max-width="400" prepend-icon="mdi-percent"
          :text="`Cette couleur est en solde, ajoutez les autres démarques!`"
          title="Ajout Promo"
          >
          <v-row>
            <v-col>
                <input type="text" v-model="demarque.SOLD1" class="form-control" placeholder="D1%" aria-label="D1" aria-describedby="basic-addon1">
            </v-col>
            <v-col>
                <input type="text" v-model="demarque.SOLD2" class="form-control" placeholder="D2%" aria-label="D2" aria-describedby="basic-addon1">
            </v-col>
            <v-col>
                <input type="text" v-model="demarque.SOLD3" class="form-control" placeholder="D3%" aria-label="D3" aria-describedby="basic-addon1">
            </v-col>
            <v-col>
                <input type="text" v-model="demarque.OUTLET" class="form-control" placeholder="OT%" aria-label="OT" aria-describedby="basic-addon1">
            </v-col>
          </v-row>
          <template v-slot:actions>
              <v-btn color="red" text="Annuler" @click="dialogAjoutSolde = false"></v-btn>
              <v-btn color="green" text="Valider" @click="addPromoSolde(demarque);dialogAjoutSolde = false;"></v-btn>
          </template>
          </v-card>
        </v-dialog>
        <v-dialog v-model="allColors" width="auto">
          <v-card max-width="400" prepend-icon="mdi-percent"
          :text="`Appliquer la remise sur toutes les couleurs?`"
          title="Ajout soldes"
          >
          <template v-slot:actions>
              <v-btn color="warning" text="Non" @click="allColors = false"></v-btn>
              <!-- ;codebarre.type_promo.match(/sol/gmi)?dialogAjoutSolde=true:false -->
              <v-btn color="green" text="Oui" @click="allColorsAdd();allColors = false"></v-btn>
          </template>
          </v-card>
        </v-dialog>
        <periode-promo v-if="dialog"
            :periodData
            v-model="dialog"
        ></periode-promo>
        <Repartition v-if="repartDialog"
            :article="props.article"
            v-model="repartDialog"
            :articleRepart="{type:'color'}"
        ></Repartition>
        <InfosQuantities v-if="qteDialog"
            :productData
            :storeOptions
            v-model="qteDialog"
        >

        </InfosQuantities>
    </div>
    <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    timeout="2000"
    location="top"
  >
    {{ snackbarMessage }}
    <template v-slot:actions>
      <v-btn color="white" variant="text" @click="snackbar = false">
        Fermer
      </v-btn>
    </template>
  </v-snackbar>
        
</template>
<script setup>
    import { ref, watch, computed} from 'vue'
    import store from './store'
    import axios from 'axios'
    import PeriodePromo from './components/PeriodePromo.vue'
    import Repartition from './components/Repartition.vue'
    import InfosQuantities from './components/InfosQuantities.vue'
    const props= defineProps({
        article :   Object,
        col     :   Object,
        cab     :   Boolean,
        repart  :   Boolean,
        visiblefunction: Boolean
    })
    let dialogSolde=ref(false)
    let d1=ref(false)
    let d2=ref(false)
    let d3=ref(false)
    let ot=ref(false)
    let repartDialog=ref(false)
    let qteDialog=ref(false)
    let localChanged=ref({ficheArticle:false,prixBase:false,promo:false,repart:false})
    let allColors=ref(false)
    let demarque=ref({
        SOLD1:'',
        SOLD2:'',
        SOLD3:'',
        OUTLET:''
    })
    let toDelete=ref(false)
    let dialogAjoutSolde=ref(false)
    let visible= defineModel()
    let isChanged=ref({
        promo:false,
        repart:false,
        fiche:false
    })
    const snackbar = ref(false)
    const snackbarMessage = ref('')
    const snackbarColor = ref('success')
    const showSnackbar = (message, color = 'success') => {
        snackbarMessage.value = message
        snackbarColor.value = color
        snackbar.value = true
    }
    const emit = defineEmits(['isChangedCol','photo_name'])
    let codebarre=computed(()=>{
        return props.article
    })

    const etabDEPO=ref({'filliale':'DEPOT', 'etabliss':['DEPO','DWEB']})
    const etabAD=ref({'filliale':'AD', 'etabliss':['DEFEC','DEPAD','LITIG','NEGO','PHOTO','RECEP','TRANS','NGEXT']})
    const etabReflex=ref({'filliale':'Reflex', 'etabliss':['WEDI','WEBE','WENL','WETR','WOOM','WCAM','WAMZ']})
    const etabEtrier= ref({'filliale':'Etrier', 'etabliss':['CA24','VX05','PR25']})
    const etabEdiBE=ref({'filliale':'Edisac Belgique', 'etabliss':['BR08','NP19','GE22','OO10']})
    const etabEdiFrNord=ref({'filliale':'Edisac Nord', 'etabliss':['DK03','MN01','EN11','FT04','LI02','RO06']})
    const etabEdiPDC=ref({'filliale':'Edisac PDC', 'etabliss':['AR09','CO18','HB21']})
    const etabLc=ref({'filliale':'Lonchamp', 'etabliss':['LO07']})
    let collectionColor=computed(()=>{
        return codebarre.value.collection})
    let typesPromo=computed(()=>{
        return codebarre.value.type_promo?[codebarre.value.type_promo]:['PBG','OUTLET','BF','SOLVP','SOLD1','SOLD2','SOLD3','BRADER','PGUESS','BAG','EXTRA']})
    let collections=ref(['E23','E24','E25','E26','E27','H23','H24','H25','H26','H27','R23','R24','R25','R26','R27'])
    const updateCollection=(value)=>{
        
        let newcol=value
        let oldcol=value
        let referenceCol=codebarre.value
        let articlesTab=store.state.articles[codebarre.value.code_marque][codebarre.value.code_theme][codebarre.value.reference_y2]
        for(let key in articlesTab){
            if(store.state.articles[codebarre.value.code_marque][codebarre.value.code_theme][codebarre.value.reference_y2][key].code_couleur==codebarre.value.code_couleur){
                store.commit('updateCollectionColor',{'referenceCol':referenceCol,'key':key,'collection':{newcol,oldcol}})  
            }
        }  
    }
    const filiale=(repart,etab,depo)=>{ 
        repart=repart?repart:0
        etab=etab?etab:0
        depo=depo?depo:0
        return etab-repart<0&&etab-depo<0?true:false
    }

        
    const etabclass2 = ref({
        'background-color': 'pink',
        'cursor': 'pointer'
    })
    const typePromo = ref({
        'color': 'red',
        'cursor': 'pointer'
    })
    const typePromoPBG = ref({
        'color': 'blue',
        'cursor': 'pointer'
    })
    const sumStock = (obj) => {
        let sum=0
        for(let keys=0;keys<obj.length;keys++){
            sum=sum+(codebarre.value.stock[obj[keys]]?Number(codebarre.value.stock[obj[keys]]):0)
        }
        return sum
    }
   
    const deletePromo= async ()=>{
      let solde=(d1.value||d2.value||d3.value||ot.value)?{d1:d1.value?'d1':false,d2:d2.value?'d2':false,d3:d3.value?'d3':false,ot:ot.value?'ot':false}:false
      let data = {articles:props.article,solde:solde,dim:true}
      let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://my.edisac.com/api/deletepromo',
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
      }
      return axios.request(config)
      .then((response) => { 
        if(response){
            d1.value=false;
            d2.value=false;
            d3.value=false;
            ot.value=false;
            toDelete.value=false
        }    
      })
      .catch((error) => {
      //console.log(error);
      });
    }
    const updatePrix=(value)=>{
        // store.commit('updateIsChangedCol',{key:'prixBase',value:true})
        // localChangedCol.value.prixBase=true
        let referenceCol=codebarre.value
        let oldPrix=value
        let newPrix=value
        let newRemise=codebarre.value.remise
        store.commit('updatePrix',{'referenceCol':referenceCol,'key':referenceCol.codebarre,'prix':{oldPrix,newPrix,newRemise},'localChangedCol':{'prixBase':true}})
        codebarre.value.remise=codebarre.value.type_promo&&codebarre.value.vte_euro!=0?`${100*(1-(codebarre.value.prix_promo/codebarre.value.vte_euro)).toFixed(1)}%`:''
        localChanged.value={
            ...localChanged.value,
            prixBase:true
        }
        
    }
    let remise=ref()
    const addPromo=(value)=>{
        isChanged.value.promo=true
        remise.value=value
        store.commit('updateIsChangedCol',{key:'promo',value:true})
        let referenceCol=codebarre.value
        let oldPrix=value
        let newPrix=value
        store.commit('updatePromo',{'referenceCol':referenceCol,'key':referenceCol.codebarre,'prix':{oldPrix,newPrix}})
        codebarre.value.remise=codebarre.value.type_promo&&codebarre.value.vte_euro!=0?`${Number(100*(1-(codebarre.value.prix_promo/codebarre.value.vte_euro))).toFixed(2)}%`:''
        if(codebarre.value.remise=='0%'){
            toDelete.value=true
        }else{
            allColors.value=true 
        }   
    }
    const allColorsAdd=()=>{
        let referenceCol=codebarre.value
        let oldPrix=remise.value //.match(/%/)?remise.value:Number(remise.value.toString().slice(0,remise.value.toString().length-1))
        let newPrix=remise.value //.match(/%/)?remise.value:Number(remise.value.toString().slice(0,remise.value.toString().length-1))
        let articlesTab=store.state.articles[codebarre.value.code_marque][codebarre.value.code_theme][codebarre.value.reference_y2]
        for(let key in articlesTab){
            if(articlesTab[key].type_promo!=''){
                store.commit('updatePromo',{'referenceCol':referenceCol,'key':key,'prix':{oldPrix,newPrix}})
            }
        }
        // if(codebarre.value.type_promo.match(/sol/gmi)){
        //     dialogAjoutSolde.value=true
        // }  
    }
    function preciseDiscount(prixPromo, vteEuro) {
        const discount = 100 * (1 - (prixPromo / vteEuro));
        // Ajouter EPSILON pour corriger les erreurs d'arrondi
        const corrected = discount + Number.EPSILON;
        return Math.round(corrected * 100) / 100;
    }

    const addPromoSolde=()=>{
        let referenceCol=codebarre.value
        for ( let i in demarque.value){
            referenceCol={...referenceCol,type_promo:i,prix_promo:codebarre.value.vte_euro*(1-demarque.value[i]/100).toFixed(1)}
             
        }  
        //console.log(referenceCol); 
    }
    const addTypePromo=(value)=>{
        store.commit('updateIsChangedCol',{key:'promo',value:true})
        // isChangedCol.key='promo'
        // {ficheArticle:false,prixBase:false,promo:false,repart:false}
        let referenceCol=codebarre.value
        let oldType=value
        let newType=value
        let articlesTab=store.state.articles[codebarre.value.code_marque][codebarre.value.code_theme][codebarre.value.reference_y2]
        for(let key in articlesTab){
            store.commit('addTypePromo',{'referenceCol':referenceCol,'key':key,'prix':{oldType,newType}})
        }  
         codebarre.value.remise=value==''?'':codebarre.value.remise  
    }
    const updateRepart=(mag,newRepart)=>{
        isChanged.value.repart=true
        let referenceCol=codebarre.value
        store.commit('updateRepart',{'referenceCol':referenceCol,'key':referenceCol.codebarre,'repart':{mag,newRepart},'localChangedCol':{'repart':true}})
    }

    const validerArticles=async ()=>{
        let referenceCol=codebarre.value
        let data = {articles:
            {
                [referenceCol.codebarre]:store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][referenceCol.codebarre],
                
            },
            isChanged               :{localChange:true},
            localChanged            :localChanged.value,
            user                    :store.state.user
        }
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/articles',
        // url: 'http://localhost:8282/apimyedisac/articles',
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        }
        return axios.request(config)
        .then((response) => { 
            localChanged.value={ficheArticle:false,prixBase:false,promo:false,repart:false}
            showSnackbar(`Le prix du code à barre ${codebarre.value.codebarre} a été modifié`, 'success')
        })
        .catch((error) => {
        });
    }
    // promotion table
    

    const periodData = ref()
    // let dialog=defineModel(false)
    const dialog = ref(false)
    async function getPeriodePromo(periode){
        
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `/cegid-api/Y2/98661025_001_PROD/api/price-list-periods/v1/${periode}?fields=StoreExceptions`, //
          headers: { 
            'Authorization': `Bearer ${store.state.token_y2}`, 
            'Content-Type': 'application/json'
          }
        };
        if(periode&&periode!=''){
            axios.request(config)
            .then((response) => {
            if(response.data){
                periodData.value=response.data
                dialog.value=true
            }
            
            })
            .catch((error) => {
            })
        }
        
      }
    let productData=ref(null)
    let storeOptions=ref(null)
    const getReliquat = async (article) => {
        try {
            const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?barcodes=${article.codebarre}&fields=Quantities`,
            headers: {
                'Authorization': `Bearer ${store.state.token_y2}`,
                'Content-Type': 'application/json'
            }
            }
            
            const response = await axios.request(config)
            if (response.data?.length > 0) {
                productData.value = response.data[0]
                //console.log(productData.value)
                storeOptions.value = productData.value.stores.map(store => { return `${store.id}`})
                qteDialog.value=true
            }
        } catch (error) {
            console.error('Erreur:', error)
        } 
    }
    // 
</script>
<style>
input {
    text-align: center;
}

.etabclass{
    width: 40px;
    text-align: center;
    border-color: lightgrey;
    
    /* border:0.01rem solid */
    }
.etabclass:hover{
    background-color: lightgrey
    }
.etabclass2{
    background-color: pink;
    text-align: center;
    cursor: pointer;
}
.promo{
    cursor: pointer;
    }

.promo:hover {
  background-color: lightgrey
}
.test{
    background-color:red
}
td{
    text-align: center;
}
.filiale{
    border-left: 0.1em  solid;
    border-color:lightgrey ;
}
select {
  font-size: 0.7rem;
  padding: 2px 5px;
}
.store-table {
  margin: 0 -16px;
}
.w-100 {
  width: 100%;
}
</style>